module.exports = __webpack_public_path__ + "img/green-filled-marker.cbd5f746.svg";